export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f128b6845993f69aaa440c8fea33746f779100ce1&name=fetchTypeahead!'